import * as React from "react";
import API from "../../../vendor/api";
import { initialize } from "redux-form";
import { connect, Dispatch } from "react-redux";
import { RootState } from "../../../redux/index";

import * as moment from "moment";
import Tab from "../../../components/Tab";
import Avatar from "../../../components/Avatar";
import SecondaryHeader from "../../../components/Header/Secondary";
import AddHistoryItem, { Fields as AddHistoryItemFields } from "../../../components/Forms/AddHistoryItem";
// import ChatList from "../../ChatList";
// import ContactList from "../../ContactList";
// import EditMyProfileForm, { fields } from "../../../components/Forms/EditMyProfile";

import { selectSidebarView } from "../../../redux/modules/ui/ui";
// import { editProfile } from "../../../redux/modules/appAuth/appAuth";

import { IChatNormalized } from "../../../types";

const s = require("./sidebar.scss");

interface Props {
    user: API.User;
    activeView: string;
    dispatch?: Dispatch<any>;
    currentChat: IChatNormalized;
};

interface State {
    currentTab: string;
    isHistoryFormOpen: boolean;
    history?: API.HistoryItem[];
};

class Sidebar extends React.Component<Props, State> {
    state: State = { currentTab: "Histórico", isHistoryFormOpen: false };

    onGoBack() {
        this.props.dispatch(selectSidebarView("chatList"));
    }

    componentDidMount() {
        const { name, email } = this.props.user;

        this.props.dispatch(initialize("EditMyProfileForm", { name, email }));

        this.updatePatientHistory();
    }

    updatePatientHistory() {
        API.patientHistory(this.props.currentChat.user.id, new Date(0))
            .then(history => this.setState({ history } as any))
            .catch(error => this.setState({ history: [
                {
                    id: "0",
                    time: new Date(),
                    medicine: "Fentanidil",
                    summary: "High on sedatives",
                }
            ] } as any));
    }

    componentWillReceiveProps(nextProps: Props) {
        const { name, email }  = nextProps.user;
        this.props.dispatch(initialize("EditMyProfileForm", { name, email }));
    }

    addHistoryItem(fields: AddHistoryItemFields) {
        API.addPatientHistory(this.props.currentChat.user.id, fields.medicine, fields.summary).then(_ => {
            this.updatePatientHistory();
            this.setState({isHistoryFormOpen: false} as any);
        });
    }

    render(): JSX.Element {
        const selectedChatUser = this.props.currentChat.user;

        return (
            <div className={s.sidebar}>
                <div className={s.header}>
                    <SecondaryHeader
                        title="Perfil"
                        onGoBack={this.onGoBack.bind(this)}
                    />
                </div>

                <div className={s.info}>
                    <Avatar image={selectedChatUser.avatar && selectedChatUser.avatar.small_url} size="big" className={s.avatar}/>

                    <div className={s.data}>
                        <div className={s.row}>
                            <label>Nome:</label>
                            <span>{selectedChatUser.name}</span>
                        </div>

                        <div className={s.row}>
                            <label>Telefone: </label>
                            <span>{selectedChatUser.phone}</span>
                        </div>
                    </div>
                </div>

                {
                    this.props.user.is_doctor ? (
                        <Tab
                            className={s.tabs}
                            active={this.state.currentTab}
                            onChange={currentTab => this.setState({currentTab} as any)}
                            tabs={{
                                "Histórico": {
                                    name: "Histórico",
                                    body: (
                                        <div className={s.tab}>
                                            {
                                                !this.state.isHistoryFormOpen ?
                                                    <div
                                                        className={s.cleanButton}
                                                        onClick={() => this.setState({isHistoryFormOpen: true} as any)}
                                                    >
                                                        Adicionar histórico
                                                    </div>
                                                : null
                                            }

                                            {
                                                this.state.isHistoryFormOpen ?
                                                    <AddHistoryItem
                                                        onCancel={() => this.setState({isHistoryFormOpen: false} as any)}
                                                        onSubmit={this.addHistoryItem.bind(this)}
                                                    />
                                                : this.state.history && this.state.history.sort((a, b) => b.time.getTime() - a.time.getTime()).map(item => (
                                                    <div key={item.id} className={s.historyItem}>
                                                        <span className={s.timestamp}>{moment(item.time).format("DD/MM/YYYY HH:MM")}</span>

                                                        <h3>Medicamento em uso:</h3>
                                                        <div className={s.content}>{item.medicine}</div>

                                                        <h3>Resumo do caso:</h3>
                                                        <div className={s.content}>{item.summary}</div>

                                                        <hr/>
                                                    </div>
                                                ))
                                            }
                                        </div>
                                    )
                                },
                            }}
                        />
                    ) : null
                }
            </div>
        );
    }
}

export default connect((state: RootState) => ({
    user: state.auth.user,
    activeView: state.ui.sidebar.view,
    currentChat: state.entities.chats.byId[state.ui.chats.selected]
}))(Sidebar);



// WEBPACK FOOTER //
// ./src/containers/Sidebar/Profile/index.tsx